let activeDebounces = [];

export class Debounce {
    constructor(callback, timeoutMs) {
        this.callback = callback;
        this.timeoutMs = timeoutMs;
        this.timer = null;
    }

    cancel() {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    }

    start() {
        if (this.timer === null) {
            this.timer = setTimeout(() => {
                this.callback();
                this.destroy();
            }, this.timeoutMs);
        }
    }

    destroy() {
        this.cancel();
        activeDebounces = activeDebounces.filter(i => i.callback !== this.callback);
    }
}

export default function debounce(callback, timeoutMs = 1000) {
    let lastDebounce = activeDebounces.find(i => i.callback.toString() === callback.toString());
    if (lastDebounce) {
        lastDebounce.destroy();
    }
    let newDebounce = new Debounce(callback, timeoutMs);
    newDebounce.start();
    activeDebounces.push(newDebounce);
}